import { Button, Divider, Grid } from '@mui/material'
import React, { useState } from 'react'
import { useTheme } from '@mui/styles'
import { TextBold, TextRegular } from '../../../commonComponents/TextStyling'
import EditIcon from '@mui/icons-material/Edit'

import UpdateQuestionModal from './UpdateQuestionModal'
import AppButton from '../../../commonComponents/AppButton'
import callServer from '../../../api/callServer'
import { isEmpty } from '../../../utils/AppHelper'

export default function UpdateProfile ({
  candidateState,
  getCandidateDetails,
  changeState
}) {
  const [updateQuestion, setUpdateQuestion] = useState({ open: false })
  const [progress, setProgress] = useState(0)
  const [progressCover, setProgressCover] = useState(0)

  var theme = useTheme()

  return (
    <Grid container>
      <Grid container xs={12} style={{ justifyContent: 'space-between' }}>
        <Grid xs={2.2} item>
          <TextRegular
            style={{
              fontSize: '50px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              border: `1px solid ${theme.palette.border.main}`,
              width: '100%',
              height: '8rem',
              borderRadius: '16px',
              overflow: 'hidden',
              padding: '8px'
            }}
          >
            {candidateState?.candidateFirstName?.substring(0, 1).toUpperCase()}
            {candidateState?.candidateLastName?.substring(0, 1).toUpperCase()}
          </TextRegular>
        </Grid>

        <Grid xs={9.8} item>
          <Grid container direction={'row'} style={{ paddingLeft: '24px' }}>
            <Grid item xs={10.5}>
              <Grid container direction={'column'}>
                <Grid item>
                  <TextBold style={{ fontSize: '20px' }}>
                    {candidateState.candidateFirstName}{' '}
                    {candidateState.candidateLastName}
                  </TextBold>
                </Grid>
                <Grid item>
                  <TextRegular style={{ fontSize: '12px' }}>
                    {candidateState.candidatePhone}
                  </TextRegular>{' '}
                  <TextRegular
                    style={{
                      fontSize: '12px',
                      margin: '0px 6px'
                    }}
                  >
                    |
                  </TextRegular>
                  <TextRegular style={{ fontSize: '12px' }}>
                    {candidateState.candidateEmail}
                  </TextRegular>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={1.5}>
              <Button
                variant='text'
                style={{
                  textTransform: 'none'
                }}
                startIcon={<EditIcon />}
                onClick={() => {
                  setUpdateQuestion({
                    open: true,
                    item: candidateState,
                    type: 'candidateDetails',
                    onReload: getCandidateDetails,
                    onClose: () => {
                      setUpdateQuestion({
                        open: false
                      })
                    }
                  })
                }}
              >
                Edit
              </Button>
            </Grid>
            <Divider style={{ width: '100%', margin: '10px 0px' }} />
            <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                flexDirection: 'row'
              }}
            >
              <Grid item>
                {candidateState.resumePath && (
                  <AppButton
                    name={
                      progress > 0
                        ? `Downloading: ${progress}%`
                        : 'Download resume'
                    }
                    fullWidth={false}
                    onClick={() => {
                      let file = candidateState.resumePath
                      let fileName = `${candidateState?.candidateFirstName}${
                        candidateState?.candidateLastName
                      }-Resume.${file.split('.').pop()}`

                      callServer.downloadFile(
                        file,
                        fileName,
                        percentCompleted => {
                          setProgress(
                            percentCompleted === 100 ? 0 : percentCompleted
                          )
                        }
                      )
                    }}
                    style={{
                      width: 'fit-content',
                      fontSize: '16px',
                      padding: '12px 27px',
                      borderRadius: '8px',
                      marginTop: '0px'
                    }}
                  />
                )}
              </Grid>
              <Grid item>
                {candidateState?.coverLetterPath && (
                  <AppButton
                    name={
                      progressCover > 0
                        ? `Downloading: ${progressCover}%`
                        : 'Download cover letter'
                    }
                    fullWidth={false}
                    onClick={() => {
                      let file = candidateState.coverLetterPath
                      let fileName = `${candidateState?.candidateFirstName}${
                        candidateState?.candidateLastName
                      }Cover.${file.split('.').pop()}`
                      callServer.downloadFile(
                        file,
                        fileName,
                        percentCompleted => {
                          setProgressCover(
                            percentCompleted === 100 ? 0 : percentCompleted
                          )
                        }
                      )
                    }}
                    style={{
                      width: 'fit-content',
                      fontSize: '16px',
                      padding: '12px 27px',
                      borderRadius: '8px',
                      marginLeft: '24px'
                    }}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Divider
        style={{
          width: '100%',
          margin: '24px 0px'
        }}
      />
      {!isEmpty(candidateState.coverSummary) && (
        <>
          <Grid item xs={11}>
            <TextBold>
              Tell the hiring manager why you are a good fit for this role?
            </TextBold>
          </Grid>

          <Grid item xs={1}>
            <Button
              variant='text'
              style={{
                textTransform: 'none'
              }}
              startIcon={<EditIcon />}
              onClick={() => {
                setUpdateQuestion({
                  open: true,
                  item: candidateState,
                  type: 'coverSummary',
                  onReload: getCandidateDetails,
                  onClose: () => {
                    setUpdateQuestion({
                      open: false
                    })
                  }
                })
              }}
            >
              Edit
            </Button>
          </Grid>

          <Grid item xs={12}>
            <TextRegular
              dangerouslySetInnerHTML={{
                __html: candidateState.coverSummary
              }}
            />
          </Grid>
          <Divider
            style={{
              width: '100%',
              margin: '24px 0px'
            }}
          />
        </>
      )}

      {!isEmpty(candidateState?.preScreenQuestions) && (
        <>
          <Grid item xs={10}>
            <TextBold>Pre screen questions</TextBold>
          </Grid>
          <Grid
            item
            xs={2}
            style={{
              display: 'flex',
              justifyContent: 'right'
            }}
          >
            <Button
              variant='text'
              style={{
                textTransform: 'none'
              }}
              startIcon={<EditIcon />}
              onClick={() => {
                setUpdateQuestion({
                  open: true,
                  item: candidateState,
                  type: 'preScreen',
                  onReload: getCandidateDetails,
                  onClose: () => {
                    setUpdateQuestion({
                      open: false
                    })
                  }
                })
              }}
            >
              Edit
            </Button>
          </Grid>
          <Grid item xs={12}>
            {candidateState?.preScreenQuestions?.map((que, index) => (
              <Grid item key={index}>
                <Grid item xs={12} style={{ marginTop: '12px' }}>
                  <TextRegular>
                    {index + 1}. {que.question}
                  </TextRegular>
                </Grid>
                <Grid item xs={12}>
                  <TextRegular>
                    Answer: {que?.answer.replaceAll('::', ', ')}
                  </TextRegular>
                </Grid>
              </Grid>
            ))}
          </Grid>

          <Grid
            item
            xs={12}
            style={{
              display: 'flex',
              justifyContent: 'center',
              padding: 0
            }}
          >
            <Divider
              style={{
                width: '100%',
                paddingLeft: 0,
                margin: '24px 0px'
              }}
            />
          </Grid>
        </>
      )}
      <Grid
        item
        xs={12}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Button
          variant='outlined'
          style={{
            textTransform: 'none',
            padding: '12px 26px'
          }}
          onClick={() => changeState(3)}
        >
          Skip
        </Button>
      </Grid>
      {updateQuestion.open && <UpdateQuestionModal data={updateQuestion} />}
    </Grid>
  )
}
